import React, { useState, useEffect, ChangeEvent, FormEvent } from "react";
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Select,
  Checkbox,
  Button,
  SimpleGrid,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  useToast,
} from "@chakra-ui/react";
import axios from "axios";

interface Propietario {
  id?: string;
  idTipoContribuyente: string;
  idTipoPropietario: number;
  idTipoVulnerable: number;
  nombre: string;
  primerApellido: string;
  segundoApellido: string;
  razonSocial: string;
  rfc: string;
  curp: string;
  telefono: string;
  fechaActualizacion: string;
  usuario: string;
  esTitular?: boolean;
}
interface ColindanciasFormProps {
    idClaveCatastral: string; // Identificador para relacionar colindancias
  }
  interface TipoPropietario {
    id: number;
    descripcion: string;
  }
  
  interface TipoVulnerable {
    id: number;
    descripcion: string;
  }
  
const PropietariosForm: React.FC<ColindanciasFormProps> = ({ idClaveCatastral }) => {
  const [propietarios, setPropietarios] = useState<Propietario[]>([]);
  const [tipoPropietarios, setTipoPropietarios] = useState<TipoPropietario[]>([]);
  const [tipoVulnerables, setTipoVulnerables] = useState<TipoVulnerable[]>([]);

  const [newPropietario, setNewPropietario] = useState<Propietario>({
    idTipoContribuyente: "",
    idTipoPropietario: 1,
    idTipoVulnerable: 0,
    nombre: "",
    primerApellido: "",
    segundoApellido: "",
    razonSocial: "",
    rfc: "",
    curp: "",
    telefono: "",
    fechaActualizacion: new Date().toISOString(),
    usuario: "admin",
    esTitular: false,
  });
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const toast = useToast();
  // Cargar tipos de propietarios
  useEffect(() => {
    
    const fetchTipoPropietarios = async () => {
      try {
        const response = await axios.get("http://52.91.130.91:5000/api/cTipoPropietarioRoutes");
        setTipoPropietarios(response.data);
      } catch {
        toast({
          title: "Error",
          description: "No se pudo cargar la lista de tipos de propietario.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    };

    const fetchTipoVulnerables = async () => {
      try {
        const response = await axios.get("http://52.91.130.91:5000/api/cTipoVulnerableRoutes");
        setTipoVulnerables(response.data);
      } catch {
        toast({
          title: "Error",
          description: "No se pudo cargar la lista de tipos vulnerables.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    };

    fetchTipoPropietarios();


    fetchTipoVulnerables();
  }, [toast]);

  // Cargar propietarios existentes
  useEffect(() => {
    axios
      .get(`http://52.91.130.91:5000/api/propietarios/${idClaveCatastral}`)
      .then((response) => setPropietarios(response.data))
      .catch(() =>
        toast({
          title: "Error",
          description: "No se pudo cargar la información de los propietarios.",
          status: "error",
          duration: 5000,
          isClosable: true,
        })
      );
  }, [toast]);

  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
  
    if (e.target.type === "checkbox") {
      // Manejo de checkboxes
      const isChecked = (e.target as HTMLInputElement).checked;
      setNewPropietario((prev) => ({
        ...prev,
        [name]: isChecked,
      }));
    } else {
      // Manejo de otros inputs y selects
      setNewPropietario((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  
  
  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    try {
      if (editingIndex !== null) {
        // Actualizar propietario existente
        const updated = await axios.put(
          `http://52.91.130.91:5000/api/propietarios/${newPropietario.id}`,
          newPropietario
        );
        setPropietarios((prev) => {
          const updatedList = [...prev];
          updatedList[editingIndex] = updated.data;
          return updatedList;
        });
        toast({
          title: "Éxito",
          description: "Propietario actualizado correctamente.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      } else {
        // Crear nuevo propietario
        const created = await axios.post(
          "http://52.91.130.91:5000/api/propietarios",
          newPropietario
        );
        setPropietarios((prev) => [...prev, created.data]);
        toast({
          title: "Éxito",
          description: "Propietario agregado correctamente.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      }

      // Resetear el formulario
      setNewPropietario({
        idTipoContribuyente: "",
        idTipoPropietario: 1,
        idTipoVulnerable: 0,
        nombre: "",
        primerApellido: "",
        segundoApellido: "",
        razonSocial: "",
        rfc: "",
        curp: "",
        telefono: "",
        fechaActualizacion: new Date().toISOString(),
        usuario: "admin",
        esTitular: false,
      });
      setEditingIndex(null);
    } catch {
      toast({
        title: "Error",
        description: "No se pudo guardar el propietario.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handleEdit = (index: number) => {
    setEditingIndex(index);
    setNewPropietario(propietarios[index]);
  };

  const handleDelete = async (id?: string) => {
    if (id) {
      try {
        await axios.delete(`http://52.91.130.91:5000/api/propietarios/${id}`);
        setPropietarios((prev) => prev.filter((p) => p.id !== id));
        toast({
          title: "Éxito",
          description: "Propietario eliminado correctamente.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      } catch {
        toast({
          title: "Error",
          description: "No se pudo eliminar el propietario.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    }
  };

  return (
    <Box p={[2, 4, 6]} maxW="1200px" mx="auto">
      <form onSubmit={handleSubmit}>
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
          <FormControl>
            <FormLabel>Tipo Contribuyente</FormLabel>
            <Select
              name="idTipoContribuyente"
              value={newPropietario.idTipoContribuyente}
              onChange={handleChange}
              placeholder="Seleccione un tipo"
              isRequired
            >
              <option value="F">Físico</option>
              <option value="M">Moral</option>
            </Select>
          </FormControl>

          <FormControl>
            <FormLabel>Tipo Propietario</FormLabel>
            <Select
              name="idTipoPropietario"
              value={newPropietario.idTipoPropietario}
              onChange={handleChange}
              placeholder="Seleccione un tipo"
              isRequired
            >
              {tipoPropietarios.map((tipo) => (
                <option key={tipo.id} value={tipo.id}>
                  {tipo.descripcion}
                </option>
              ))}
            </Select>
          </FormControl>

          <FormControl>
            <FormLabel>Tipo Vulnerable</FormLabel>
            <Select
              name="idTipoVulnerable"
              value={newPropietario.idTipoVulnerable}
              onChange={handleChange}
              placeholder="Seleccione un tipo"
              isRequired
            >
              {tipoVulnerables.map((tipo) => (
                <option key={tipo.id} value={tipo.id}>
                  {tipo.descripcion}
                </option>
              ))}
            </Select>
          </FormControl>

          <FormControl>
            <FormLabel>Nombre</FormLabel>
            <Input
              name="nombre"
              value={newPropietario.nombre}
              onChange={handleChange}
              placeholder="Nombre"
              isRequired
            />
          </FormControl>

          <FormControl>
            <FormLabel>Primer Apellido</FormLabel>
            <Input
              name="primerApellido"
              value={newPropietario.primerApellido}
              onChange={handleChange}
              placeholder="Primer Apellido"
              isRequired
            />
          </FormControl>

          <FormControl>
            <FormLabel>Segundo Apellido</FormLabel>
            <Input
              name="segundoApellido"
              value={newPropietario.segundoApellido}
              onChange={handleChange}
              placeholder="Segundo Apellido"
            />
          </FormControl>

          <FormControl>
            <FormLabel>Razón Social</FormLabel>
            <Input
              name="razonSocial"
              value={newPropietario.razonSocial}
              onChange={handleChange}
              placeholder="Razón Social"
            />
          </FormControl>

          <FormControl>
            <FormLabel>RFC</FormLabel>
            <Input
              name="rfc"
              value={newPropietario.rfc}
              onChange={handleChange}
              placeholder="RFC"
            />
          </FormControl>

          <FormControl>
            <FormLabel>CURP</FormLabel>
            <Input
              name="curp"
              value={newPropietario.curp}
              onChange={handleChange}
              placeholder="CURP"
            />
          </FormControl>

          <FormControl>
            <FormLabel>Teléfono</FormLabel>
            <Input
              name="telefono"
              value={newPropietario.telefono}
              onChange={handleChange}
              placeholder="Teléfono"
            />
          </FormControl>

          <FormControl>
            <FormLabel>Es Titular</FormLabel>
            <Checkbox
    name="esTitular"
    isChecked={newPropietario.esTitular}
    onChange={handleChange}
  >
    Es Titular
  </Checkbox>
          </FormControl>
        </SimpleGrid>

        <Button type="submit" colorScheme="blue" mt={4}>
          {editingIndex !== null ? "Actualizar Propietario" : "Agregar Propietario"}
        </Button>
      </form>

      <Box overflowX="auto" mt={8}>
  <Table variant="simple">
    <Thead>
      <Tr>
        <Th>Nombre</Th>
        <Th display={{ base: "none", md: "table-cell" }}>RFC</Th>
        <Th display={{ base: "none", lg: "table-cell" }}>CURP</Th>
        <Th>Acciones</Th>
      </Tr>
    </Thead>
    <Tbody>
      {propietarios.map((propietario, index) => (
        <Tr key={propietario.id}>
          <Td>
            {propietario.nombre} {propietario.primerApellido} {propietario.segundoApellido}
          </Td>
          <Td display={{ base: "none", md: "table-cell" }}>{propietario.rfc}</Td>
          <Td display={{ base: "none", lg: "table-cell" }}>{propietario.curp}</Td>
          <Td>
            <Button size="sm" colorScheme="green" onClick={() => handleEdit(index)}>
              Editar
            </Button>
            <Button
              size="sm"
              colorScheme="red"
              onClick={() => handleDelete(propietario.id)}
              ml={2}
            >
              Eliminar
            </Button>
          </Td>
        </Tr>
      ))}
    </Tbody>
  </Table>
</Box>

    </Box>
  );
};

export default PropietariosForm;
